/** Blender-authored Atlantica. Metres, Y-up, +Z bow, waterline origin. */
import { Group, Mesh, Vector3 } from 'three/webgpu'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

export async function loadTugModel(): Promise<Group> {
  const { scene } = await new GLTFLoader().loadAsync('/models/tug/atlantica.glb')
  const vessel = new Group()
  vessel.name = 'tug-atlantica-blender'
  scene.rotation.y = -Math.PI / 2
  vessel.add(scene)
  vessel.updateMatrixWorld(true)
  // The replacement keeps the original gameplay rig exactly in place.
  const attachments: [string, Vector3][] = [
    ['tow_point_stern', new Vector3(0, 2.5, -6.4)],
    ['camera_bridge', new Vector3(0, 6, 2.2)],
    ['wake_stern', new Vector3(0, -1.4, -8.6)],
    ['exhaust', new Vector3(0, 6.6, -.7)],
  ]
  for (const [name, expected] of attachments) {
    const node = vessel.getObjectByName(name)
    if (!node || node.getWorldPosition(new Vector3()).distanceTo(expected) > .001) {
      throw new Error(`Atlantica attachment does not match the gameplay rig: ${name}`)
    }
  }
  vessel.traverse(object => {
    if (!(object as Mesh).isMesh) return
    object.castShadow = true
    object.receiveShadow = true
  })
  return vessel
}
